// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__g5CZ_","inputWrap":"styles_inputWrap__2uPwA","input":"styles_input__2Qx-_"};